// @flow

const isObjectEmpty = (obj: {}): boolean => Object.keys(obj).length === 0;

const isArrayEmpty = (array: Array<any>) => array.length === 0;

const isStringEmpty = (string: String) => string === '';

/**
 * Determines if a string, array or object is empty.
 * Throws an error if provided anything else
 * @returns {boolean}
 * @param object
 */
const isEmpty = (object: {} | Array<any> | String): boolean => {
  if (typeof object === 'string') {
    return isStringEmpty(object);
  }

  if (Array.isArray(object)) {
    return isArrayEmpty(object);
  }

  if (typeof object === 'object') {
    return isObjectEmpty(object);
  }

  throw new Error(
    `Argument is not a recognized type of object, array, or string. Given ${typeof object}`,
  );
};

export default isEmpty;
